<template>
    <portal to="dash">
        <transition name="fade">
            <div
                v-if="active"
                key="drop-file"
                class="drop-file-overlay"
                @dragover.prevent
                @dragleave.prevent="handleDragLeave"
                @drop.prevent="onDrop"
                @mousemove="handleDragLeave"
            >
            <div class="drop-card">
                <div class="icon">📥</div>
                <h3>Déposez vos fichiers</h3>
                <p>Relâchez pour lancer l'upload</p>
            </div>
            </div>
        </transition>
    </portal>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
    props: {
        targetInput: {
            default: null
        }
    },
    data() {
        return {
        active: false,
        dragCounter: 0
        };
    },
    mounted() {
        window.addEventListener('dragenter', this.handleWindowDragEnter);
        window.addEventListener('dragleave', this.handleWindowDragLeave);
    },
    beforeDestroy() {
        window.removeEventListener('dragenter', this.handleWindowDragEnter);
        window.removeEventListener('dragleave', this.handleWindowDragLeave);
    },
    methods: {
        handleWindowDragEnter(e) {
            e.preventDefault();
            // Vérifier qu'il s'agit bien de fichiers
            if (e.dataTransfer.types && e.dataTransfer.types.includes('Files')) {
                this.dragCounter++;
                this.active = true;
            }
        },
        handleWindowDragLeave(e) {
            e.preventDefault();
            this.dragCounter--;
            if (this.dragCounter <= 0) {
                this.active = false;
                this.dragCounter = 0;
            }
        },
        handleDragLeave() {
            this.active = false;
            this.dragCounter = 0;
        },
        onDrop(e) {
            this.active = false;
            this.dragCounter = 0;
            
            const files = Array.from(e.dataTransfer.files);
            if (this.targetInput) {
                const dataTransfer = new DataTransfer();
                Array.from(files).forEach(file => dataTransfer.items.add(file));
                this.targetInput.files = dataTransfer.files;
                this.targetInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.drop-file-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(10, 10, 15, 0.85);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .drop-card {
    pointer-events: none; // Crucial pour la stabilité
    width: 100%;
    max-width: 450px;
    padding: 60px 20px;
    border: 2px dashed rgba(255, 255, 255, 0.4);
    border-radius: 24px;
    text-align: center;
    color: white;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.05);

    .icon {
      font-size: 64px;
      margin-bottom: 20px;
    }

    h3 {
      font-size: 1.5rem;
      margin-bottom: 8px;
    }

    p {
      opacity: 0.7;
    }
  }
}

// Animations de transition
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
  .drop-card { transition: transform 0.3s ease; }
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  .drop-card { transform: scale(0.9); }
}
</style>